import { QueovalBase } from "../global";
import { Recipient } from "../mail";


/**
 * Modèle générique pour les documents
 **/
export class DocumentModel extends QueovalBase {
  public ListDocument: Array<DocumentGeneric>;
  public RecipientList: Array<Recipient>;
  public Type: string;
  public IdPere: string;
}

export class DocumentGeneric {
  public Ident: string;
  public Title: string;
  public Code: string;
  public IsSelected: boolean;
  public TypeDoc: string;
  public ListElementLinked: Array<LinkedElement>;
}

export class LinkedElement {
  public Ident: string;
  public Text: string;
  public Img: string;
  public NbOccur: number;
}
